import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'htmlEncode', standalone: true })
export class HtmlEncodePipe implements PipeTransform {
  transform(value: string): string {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  // Moved displayRenderedFields logic here as a utility-like method
  static displayRenderedFields(aoFields: any[]): any[] {
    const renderedFields: any[] = [];
    const appScope = (window as any).appScope;

    if (!appScope?.jobFieldsToDisplay || !aoFields) return renderedFields;

    const getField = (name: string) =>
      aoFields.find(field => field.QuestionName?.toLowerCase() === name?.toLowerCase());

    if (
      (!appScope.bresponsiveCandidateZone || !appScope.bCandidateZone || appScope.bSimiliarJobs) &&
      appScope.jobFieldsToDisplay.Position1
    ) {
      const field = getField(appScope.jobFieldsToDisplay.Position1);
      if (field) {
        field.ClassName = 'position1';
        renderedFields.push(field);
      }
    }

    if (appScope.jobFieldsToDisplay.JobTitle) {
      const field = getField(appScope.jobFieldsToDisplay.JobTitle);
      if (field) {
        field.ClassName = 'jobtitle';
        renderedFields.push(field);
      }
    }

    if (Array.isArray(appScope.jobFieldsToDisplay.Position3)) {
      appScope.jobFieldsToDisplay.Position3.forEach((qName: string) => {
        const field = getField(qName);
        if (field) {
          field.ClassName = 'position3';
          renderedFields.push(field);
        }
      });
    }

    if (appScope.jobFieldsToDisplay.Summary) {
      const field = getField(appScope.jobFieldsToDisplay.Summary);
      if (field) {
        field.ClassName = 'jobdescription';
        renderedFields.push(field);
      }
    }

    const lastUpdatedField = aoFields.find(f => f.QuestionName?.toLowerCase() === 'lastupdated');
    if (
      lastUpdatedField?.Value?.includes('T') &&
      appScope.jobFieldsToDisplay.Position1?.toLowerCase() === 'lastupdated'
    ) {
      const [year, month, day] = lastUpdatedField.Value.split('T')[0].split('-');
      lastUpdatedField.Value = `${month}/${+day}/${+year}`;
    }

    return renderedFields;
  }
}
